import { DatePicker } from 'antd';
import classNames from 'classnames';
import Icon from '../../icons';
import { CustomDatePickerProps } from '../../interfaces/datePicker';
import './styles.scss';

const FULL_DATE_FORMAT = 'DD-MM-YYYY';
const CustomDatePicker: React.FC<CustomDatePickerProps> = props => {
  const {
    width,
    style,
    className,
    placement = 'bottomRight',
    suffixIcon = <Icon name="calendar" color="var(--primary)" />,
    formatFullDate = false,
    format,
    ...rest
  } = props;

  const newStyle = { ...style, width };

  return (
    <DatePicker
      {...rest}
      style={newStyle}
      placement={placement}
      suffixIcon={suffixIcon}
      popupClassName="custom-date-picker-dropdown"
      className={classNames(className, 'custom-date-picker')}
      format={formatFullDate ? FULL_DATE_FORMAT : format}
    />
  );
};

export default CustomDatePicker;
